module.exports = __webpack_public_path__ + "media/images/empty-panel-9508c210184cd1036b55e92bddedefee.png";